import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Left: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m304.33 580.54-185.25-187.65 185.09-193.27 21.66 20.76-164.91 172.19 164.75 166.89z' />
    <path d='m210 375.35h380v30h-380z' transform='matrix(.99999816 -.00191986 .00191986 .99999816 -.72 .74)' />
    <path d='m660 405h-90s0-30 0-30h60c16.57 0 30 13.43 30 30z' />
  </IconBase>
));

Left.displayName = 'Left';

export default Left;
